import menuBreadcrumbsView from './menuBreadcrumbsView.html';
import './menuBreadcrumbsStyles.css';
import _ from 'lodash';

export default function menuBreadcrumbsComponent() {
	return {
		restrict: 'E',
		scope: {},
		bindToController: {
			menu: '@?',
			items: '<?',
			useAsDocumentTitle: '=',
		},
		controllerAs: 'vm',
		controller: menuBreadcrumbsComponentCtrl,
		template: menuBreadcrumbsView,
	};
}

class menuBreadcrumbsComponentCtrl {
	constructor(Menu, Theme) {
		'ngInject';
		if (!this.items) {
			this.items = [];
		}
		if (this.menu) {
			let fromMenu = Menu.breadcrumbs(this.menu);
			if (fromMenu) {
				this.items = fromMenu.concat(this.items);
			}
		}
		if (this.useAsDocumentTitle) {
			// have to clone, or it will reverse the real this.items and that
			/// shows up in the breadcrumbs
			var breadcrumbItems = _.clone(this.items);
			breadcrumbItems.reverse();

			// Append the appname value to the title, unless it's empty, in which case just append "Sharpr".
			const appName = (Theme.data().appname || '').trim(); // NOTE: Avoiding the weird case of all whitespace.

			document.title = _.map(breadcrumbItems, 'text').join(' :: ') + ' :: ' + (appName || 'Sharpr');
		}
	}

	isCurrentPage(item) {
		var currentPath = window.location.pathname + window.location.hash;
		var isCurrentPage = false;
		if (currentPath == item.href) {
			isCurrentPage = true;
		}

		return isCurrentPage;
	}
}
